// extracted by mini-css-extract-plugin
export var dropdownContainer = "_kt-0";
export var leftAlign = "_kt-4";
export var listItem = "_kt-2";
export var listItemWrapper = "_kt-1";
export var operationText = "_kt-3";